import { useUI } from "providers/UIProvider"

import { getColumns } from "./columns"
import { getNestedColumns } from "./nestedColumns"
import { getActions } from "./actions"

import Table from "components/UI/organisms/Table"
import AddEditEmployeeModal from "components/shared/modals/AddEditEmployeeModal"
import { useEmployeesContext } from "providers/EmployeesProvider"
import { IEmployee } from "api/querries/useGetEmployees"
import BdsLogo from "assets/img/bds-logo.png"
import { Text, Image, Flex } from "@chakra-ui/react"

const EmployeesTable: React.FC = () => {

  const { modals, toggleModal, T, lang } = useUI()
  const { employees, currentPage, handlePageChange, updateEmployee, handleDeleteEmployee } = useEmployeesContext()

  const handleEditClick = (data: IEmployee) => {
    toggleModal("addEditEmployeeModal", true, data)
  }
  const handleDeleteClick = (data: IEmployee) => {
    toggleModal("confirmationModal", true, {
      // keyword - employees.delete_popup.title
      title: "დარწმუნებული ხართ, რომ გსურთ თანამშრომლის წაშლა",
      handleSubmit: () => handleDeleteEmployee(data.id)
    })
  }

  const tableActions = getActions({ T, handleEditClick, handleDeleteClick })

  const columns = getColumns(T, { updateEmployee })
  const nestedColumns = getNestedColumns(T, lang)

  return (
    <>
      {modals.addEditEmployeeModal && (
        <AddEditEmployeeModal />
      )}
      {/* <ConfirmationModal
        title={t("employees.form.delete_confirmation_title")}
        isOpen={modals.confirmationModal.isOpened}
        onClose={() => toggleModal("confirmationModal", false)}
        handleDeny={() => toggleModal("confirmationModal", false)}
        handleSubmit={handleDeleteEmployee}
      /> */}
      <Table
        data={employees.data || []}
        columns={columns}
        nestedColumns={nestedColumns}
        actions={tableActions}
        pagination={{ total: employees.itemCount, perPage: 10, onClick: handlePageChange, currentPage }}
        extraHeaderCols={1}
      />
      <Flex style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", height: "2rem" }}>
        <Text style={{
          opacity: "50%",
          fontSize: "11px",
          whiteSpace: "nowrap",
        }}>
          {"Powered by"}
        </Text>
        <a target='_blank'
          rel='noopener noreferrer' href="https://bds.ge">
          <Image alt="BDS Logo" src={BdsLogo} height="14px" />
        </a>
      </Flex>
    </>
  )
}

export default EmployeesTable

